export type BuildingLookupFailureCode =
  | "not_found"
  | "forbidden"
  | "unauthenticated"
  | "unexpected";

type ExplicitLookupFailureCode = Exclude<BuildingLookupFailureCode, "unexpected">;
const FAILURE_MESSAGES: Record<ExplicitLookupFailureCode, string> = {
  not_found: "Building not found",
  forbidden: "Access denied",
  unauthenticated: "Authentication required",
};

/** A completed lookup with a known access outcome. Other errors remain unexpected. */
export class BuildingLookupError extends Error {
  constructor(readonly code: ExplicitLookupFailureCode) {
    super(FAILURE_MESSAGES[code]);
    this.name = "BuildingLookupError";
  }
}
